import { render, staticRenderFns } from "./GoalCard.vue?vue&type=template&id=e4b25dc6&scoped=true&"
import script from "./GoalCard.vue?vue&type=script&lang=js&"
export * from "./GoalCard.vue?vue&type=script&lang=js&"
import style0 from "./GoalCard.vue?vue&type=style&index=0&id=e4b25dc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b25dc6",
  null
  
)

export default component.exports